import { memoize } from "lodash";

// Avoid creating Intl formatters on every invocation. lodash memoize keys on
// the first argument only by default, which would collapse different options
// objects for the same locale into one cached formatter — key on all args.
const allArgsKey = (...args: unknown[]) => JSON.stringify(args);

export const relativeTimeFormat = memoize((...args: ConstructorParameters<(typeof Intl)["RelativeTimeFormat"]>) => {
  return new Intl.RelativeTimeFormat(...args);
}, allArgsKey);

export const dateTimeFormat = memoize((...args: ConstructorParameters<(typeof Intl)["DateTimeFormat"]>) => {
  return new Intl.DateTimeFormat(...args);
}, allArgsKey);

export const numberFormat = memoize((...args: ConstructorParameters<(typeof Intl)["NumberFormat"]>) => {
  return new Intl.NumberFormat(...args);
}, allArgsKey);
